<template>
    <footer class="bg-dark">
        <div class="style_bg_img">
            <div class="style_bg_img_bloc d-flex flex-column justify-content-center"
                style="background: linear-gradient(180deg, rgba(33, 37, 41,1) 10%, rgba(33, 37, 41, 0.9) 57.46%, rgba(33, 37, 41,1)100%);">
                <div class="container py-5">
                    <div class="d-flex align-items-end justify-content-center gap-5" style=" min-height: 200px;">
                        <div class="text-white" data-aos="fade-down" data-aos-easing="ease-out-cubic"
                            data-aos-duration="1000">
                            <h4>Vous souhaitez faire</h4>
                            <h1 class="style_bold display-5">Carrière <span class="text-primary">dans le domaine</span>
                                de l'Expertise Comptable</h1>
                        </div>
                        <router-link to="/condition-inscription" class="btn btn-primary btn-lg text-nowrap style_gradient" type="button">Nous
                            rejoindre</router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="pt-5">
            <div class="container py-5">
                <div class="row text-center text-sm-start">
                    <div class="col-sm mb-2">
                        <div class="mb-3">
                            <a href="#">
                                <img src="../../assets/img/Image3.png" alt="logo_oecca" width="100">
                            </a>
                        </div>
                        <div class="mb-4">
                            <form class="mb-2">
                                <div class="input-group">
                                    <input type="text" class="form-control form-control-lg style_form_light"
                                        placeholder="Addresse Mail" name="">
                                    <button class="btn btn-outline-secondary" type="button">
                                        <i class="bi-send"></i>
                                    </button>
                                </div>
                            </form>
                            <p class="text-opacity-75 text-white">Restez connecter à <span class="notranslate">OECCA BENIN</span> pour ne rien raté</p>
                        </div>      
                        <div class="mb-3">
                            <div class="d-flex justify-content-center justify-content-sm-start mt-3 mb-2">
                                <div class="my-auto me-4 text-opacity-75 text-white">
                                    <a href="https://www.facebook.com/profile.php?id=61576779472470" target="_blank" class="">
                                        <h3><i class="bi-facebook"></i></h3>
                                    </a>
                                </div>
                                
                                <div class="my-auto me-4 text-opacity-75 text-white">
                                    <a href="www.linkedin.com/in/oecca-benin-7b7488367" target="_blank" class="">
                                        <h3><i class="bi-linkedin"></i></h3>
                                    </a>
                                </div>
                                
                                <div class="my-auto me-4 text-opacity-75 text-white">
                                    <a href="www.youtube.com/@oeccabenin36" target="_blank" class="">
                                        <h3><i class="bi-youtube"></i></h3>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm mb-2">
                        <div class="mb-3">
                            <h5 class="mb-4 text-primary">A propos de nous</h5>
                            <ul class="mr-3 list-group list-group-flush">
                                <li class="list-group-item bg-transparent px-0 pb-4 pt-0 border-0 text-white-50">
                                    <p class="mb-0">Créé par la Loi n°2022-35 du 23 février 2023 modifiant et complétant celle n°2004-03 du 27 avril 2006, l’Ordre des experts-comptables et comptables agréés en République du Bénin regroupe tous les professionnels habilités à exercer la profession comptable ou l’activité d’expertise comptable dans les conditions fixées par la loi. </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-sm-auto mb-2">
                        <div class="mb-3">
                            <h5 class="mb-4 text-primary">Liens utiles</h5>
                            <ul class="mr-3 list-group list-group-flush">
                                <li class="list-group-item bg-transparent px-0 pb-4 pt-0 border-0 text-white-50">
                                    <p class="mb-0"><a href="#" class="">Tableau Personnes Physiques</a></p>
                                </li>
                                <li class="list-group-item bg-transparent px-0 pb-4 pt-0 border-0 text-white-50">
                                    <p class="mb-0"><a href="#" class="">Tableau Personnes Morales & CGA </a></p>
                                </li>
                                <li class="list-group-item bg-transparent px-0 pb-4 pt-0 border-0 text-white-50">
                                    <p class="mb-0"><a href="#" class="">Honoraires</a></p>
                                </li>
                                
                            </ul>
                        </div>
                    </div>
                    <div class="col-sm mb-2">
                        <div class="mb-3">
                            <h5 class="mb-4 text-primary">Contacts</h5>
                            <ul class="mr-3 list-group list-group-flush">
                                <li class="list-group-item bg-transparent px-0 pb-4 pt-0 border-0 text-white-50">
                                    <p class="mb-0">Email</p>
                                    <p class="mb-0"><a href="#" class="">contact@oeccabenin.bj</a></p>
                                </li>
                                <li class="list-group-item bg-transparent px-0 pb-4 pt-0 border-0 text-white-50">
                                    <p class="mb-0">Téléphone</p>
                                    <p class="mb-0"><a href="#" class="">(+229) 01 99 89 50 50</a></p>
                                </li>
                                <li class="list-group-item bg-transparent px-0 pb-4 pt-0 border-0 text-white-50">
                                    <p class="mb-0">Localisation</p><p class="mb-0">Carré 7007, Villa R+2 en face de la GIZ - Quartier les Cocotiers - Cotonou</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="style_gradient text-white">
            <div class="container py-3">
                <div class="d-flex flex-wrap justify-content-between align-items-center">
                    <h6 class="my-2">Copyright {{ currentYear }}. Touts droits réservés</h6>
                    <div class="d-flex flex-wrap">
                        <h6 class="my-2 me-4"><router-link to="/mentions-legales" class="">Mentions Légales</router-link></h6>
                        <h6 class="my-2 me-4"><router-link to="/condition-generale-utilisation" class="">Condition Générales d'Utilisation</router-link></h6>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  }
};
</script>

<style scoped>
.style_bg_img {
    background-image: url('@/assets/img/footer_img.jpg');
}
</style>